import { ClipLoader } from 'react-spinners';
import s from './Loading.module.scss';

const Loading = ({ loading }) => {
  return (
    <div className={s.loadingWrapper}>
        <img
            src="/loader.gif"
            alt="Loading..."
            className={s.loaderGif}
        />
    </div>
  );
};

export default Loading;
